import type { ReactNode } from 'react';
import { Card, CardContent, Typography } from '@eye-able/ui';
import { useGovernanceAccess } from '@/hooks/useGovernanceAccess';
import { useGovernanceVisibility } from '@/hooks/useGovernanceVisibility';
import { T } from '@/i18n/T';
import { GovernanceActivationContactButton } from './GovernanceActivationContactButton';

export function GovernanceAccessBoundary({
  children,
}: {
  children: ReactNode;
}) {
  const access = useGovernanceAccess();
  const visibility = useGovernanceVisibility();

  if (access.isLoading || visibility.isLoading) {
    return null;
  }

  if (!visibility.isVisible || !access.hasAccess) {
    return (
      <div className='eye:flex eye:min-h-[320px] eye:items-center eye:justify-center'>
        <Card className='eye:w-full eye:max-w-[560px]'>
          <CardContent className='eye:flex eye:flex-col eye:gap-4xs eye:p-m'>
            <Typography tag='h1' variant='headline-m'>
              <T k='noAccess' />
            </Typography>
            {!visibility.isVisible ? (
              <>
                <Typography className='eye:text-grey-120'>
                  <T k='customPoliciesNotActivatedDescription' />
                </Typography>
                <GovernanceActivationContactButton />
              </>
            ) : (
              <Typography className='eye:text-grey-120'>
                <T k='contactOrgAdmin' />
              </Typography>
            )}
          </CardContent>
        </Card>
      </div>
    );
  }

  return children;
}
